import { render, staticRenderFns } from "./menu-diet-date.vue?vue&type=template&id=6634da22&"
import script from "./menu-diet-date.vue?vue&type=script&lang=js&"
export * from "./menu-diet-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports